var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import DateHeader from 'components/PageHeader/DateHeader';
import services from 'services';
import DoctorQueue from './Queue';
import DoctorPicker from './DoctorPicker';
import './style.css';
var COLUMN_MIN = 320;
var COLUMN_GAP = 24;
var columnsThatFit = function (width) {
    if (width <= 0)
        return 1;
    return Math.max(1, Math.floor((width + COLUMN_GAP) / (COLUMN_MIN + COLUMN_GAP)));
};
var sameDoctorOrder = function (prev, next) {
    return (prev.length === next.length &&
        prev.every(function (doctor, index) { return doctor.getId() === next[index].getId(); }));
};
var index = function () {
    var _a;
    var doctorService = services.doctorService, clinicService = services.clinicService, userService = services.userService, specializationService = services.specializationService;
    var data = doctorService.useDoctors().data;
    var clinics = clinicService.useClinics().data;
    var loggedInData = userService.useLoginData().data;
    var specializations = specializationService.useSpecializations().data;
    var _b = useState(new Date()), date = _b[0], setDate = _b[1];
    var _c = useState([]), doctors = _c[0], setDoctors = _c[1];
    var _d = useState(3), columnCapacity = _d[0], setColumnCapacity = _d[1];
    var boardRef = useRef(null);
    useEffect(function () {
        if (!Array.isArray(data)) {
            return;
        }
        setDoctors(function (prev) {
            if (!prev.length) {
                return data;
            }
            var doctorsById = new Map(data.map(function (doctor) { return [doctor.getId(), doctor]; }));
            var ordered = prev
                .map(function (doctor) { return doctorsById.get(doctor.getId()); })
                .filter(function (doctor) { return Boolean(doctor); });
            var prevIds = new Set(prev.map(function (doctor) { return doctor.getId(); }));
            var newcomers = data.filter(function (doctor) { return !prevIds.has(doctor.getId()); });
            var next = __spreadArray(__spreadArray([], ordered, true), newcomers, true);
            return sameDoctorOrder(prev, next) ? prev : next;
        });
    }, [data]);
    useEffect(function () {
        var node = boardRef.current;
        if (!node)
            return;
        var measure = function () {
            var styles = window.getComputedStyle(node);
            var padding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
            var width = node.clientWidth - padding;
            setColumnCapacity(columnsThatFit(width));
        };
        measure();
        var observer = new ResizeObserver(measure);
        observer.observe(node);
        return function () { return observer.disconnect(); };
    }, []);
    var doctorQueue = doctors;
    var visibleCount = Math.min(doctorQueue.length, columnCapacity);
    var getDoctorSpecialization = function (doctor) {
        var _a, _b;
        return ((_a = doctor.getSpecialization()) === null || _a === void 0 ? void 0 : _a.getName())
            || ((_b = specializationService
                .getSpecializationDataByID(specializations, doctor.getSpecializationId())) === null || _b === void 0 ? void 0 : _b.getName())
            || '';
    };
    return (_jsxs("div", { className: "home-page", children: [clinics && loggedInData && (_jsx(DateHeader, { clinic: clinicService.getClinicByCode(clinics, loggedInData === null || loggedInData === void 0 ? void 0 : loggedInData.clinicCode), date: date, setDate: setDate })), _jsxs("div", { className: "home-page__body", ref: boardRef, children: [doctorQueue.length > visibleCount ? (_jsx("div", { className: "home-page__finder", children: _jsx(DoctorPicker, { doctors: doctorQueue, setDoctors: setDoctors }) })) : null, _jsx("div", { className: "home-page__columns", style: (_a = {}, _a['--home-columns'] = Math.max(visibleCount, 1), _a), children: doctorQueue.slice(0, visibleCount).map(function (doctor) {
                            var _a;
                            return (_jsx("div", { className: "home-page__column", children: _jsx(DoctorQueue, { doctor_id: doctor.getId(), doctor_name: (_a = doctor.getUser()) === null || _a === void 0 ? void 0 : _a.getName(), doctor_specialization: getDoctorSpecialization(doctor), date: date }) }, "doctor-queue-".concat(doctor.getId())));
                        }) })] })] }));
};
export default index;
